import {
  FETCH_USER_BEGIN,
  FETCH_USER_BY_ID_BEGIN,
  FETCH_USER_BY_ID_FAILURE,
  FETCH_USER_BY_ID_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_SUCCESS,
  UPDATE_USER_BEGIN,
  UPDATE_USER_FAILURE,
  UPDATE_USER_SUCCESS
} from "../actions/userActions";

export const createUserByIdEntry = (overrides = {}) => ({
  data: undefined,
  loading: true,
  error: null,
  ...overrides
});

const INITIAL_STATE = {
  user: {
    firstName: "",
    lastName: "",
    settings: { show_banner: false, preferred_language: "en" },
    signInCount: 0,
    permissions: {}
  },
  usersById: {},
  loading: true,
  error: null
};

function UserReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_USER_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        user: action.payload.user
      };
    }

    case FETCH_USER_FAILURE:
      // The request failed. It's done. So set loading to "false".
      // Save the error, so we can display it somewhere.
      // Since it failed, we don't have items to display anymore, so set `items` empty.
      //
      // This is all up to you and your app though:
      // maybe you want to keep the items around!
      // Do whatever seems right for your use case.
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        user: {}
      };

    case FETCH_USER_BY_ID_BEGIN: {
      const { id } = action.payload;
      const existing = state.usersById[id];
      return {
        ...state,
        usersById: {
          ...state.usersById,
          [id]: createUserByIdEntry({
            data: existing?.data,
            loading: true,
            error: null
          })
        }
      };
    }

    case FETCH_USER_BY_ID_SUCCESS: {
      const { id, user } = action.payload;
      return {
        ...state,
        usersById: {
          ...state.usersById,
          [id]: createUserByIdEntry({
            data: user,
            loading: false,
            error: null
          })
        }
      };
    }

    case FETCH_USER_BY_ID_FAILURE: {
      const { id, error } = action.payload;
      const existing = state.usersById[id];
      return {
        ...state,
        usersById: {
          ...state.usersById,
          [id]: createUserByIdEntry({
            data: existing?.data,
            loading: false,
            error
          })
        }
      };
    }

    case UPDATE_USER_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case UPDATE_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    case UPDATE_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
}

export default UserReducer;

export const selectUserById = (state, id) =>
  state.userState?.usersById?.[id] ?? createUserByIdEntry();
